
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import Switch from "react-switch";
import Resizer from "react-image-file-resizer";
import LOGO from "../../../assets/images/logo.png";
import SignatureCanvas from 'react-signature-canvas';
import Pagination from '@mui/material/Pagination';
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal_create: false,
            modal_delete: false,
            modal_update: false,
            modal_password: false,


            loading: false,
            data: null,
            data_role: [],

            user_id: "",
            user_code: "",
            full_name: "",
            phone: "",
            email: "",
            role_id: "",
            role_name: "",
            picture: "",
            is_active: false,
            user_type: "",

            page: 1,
            data_search: "",
            user_id: "",

        }
    }
    async componentDidMount() {
        await this.Get();
        await this.GetRoleAll();
    }
    Get = async () => {
        this.setState({ loading: true });
        let body = {
            page: this.state.page,
            data_search: this.state.data_search,
            user_id: this.state.user_id
        }
        let result = await GET(tokens, "v1/TH/user-admin/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data: result });
        }
        this.setState({ loading: false });
    }
    GetRoleAll = async () => {
        this.setState({ loading: true });
        let body = {
            page: 1,
            data_search: "",
            role_id: ""
        }
        let result = await GET(tokens, "v1/TH/role-manage/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result)
            this.setState({ data_role: result.data.map(e => { return { value: e.role_id, label: e.role_name } }) })
        }
        this.setState({ loading: false });
    }
    Create = async () => {
        this.setState({ loading: true });
        let body = {
            password: this.state.password,
            role_id: this.state.role_id ? this.state.role_id.value : "",
            full_name: this.state.full_name,
            phone: this.state.phone,
            email: this.state.email,
            picture: this.state.picture,
            is_active: true,
            user_type: this.state.user_type
        }
        let result = await POST(tokens, "v1/TH/user-admin/create/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            success_url("/master/list-admin")
        }
        this.setState({ loading: false });
    }
    Update = async () => {
        this.setState({ loading: true });
        let body = {
            user_id: this.state.user_id,
            password: this.state.password,
            role_id: this.state.role_id ? this.state.role_id.value : "",
            full_name: this.state.full_name,
            phone: this.state.phone,
            email: this.state.email,
            picture: this.state.picture,
            is_active: true,
            user_type: this.state.user_type
        }
        let result = await PUT(tokens, "v1/TH/user-admin/update", body);
        if (result && result.status) {
            success_url("/master/list-admin")
        }
        this.setState({ loading: false });
    }
    Delete = async () => {
        this.setState({ loading: true });
        let result = await DELETE(tokens, "v1/TH/user-admin/delete/" + this.state.user_id, null);
        if (result && result.status) {
            success_url("/master/list-admin")
        }
        this.setState({ loading: false });
    }

    import_file = (e) => {
        this.changePhoto(e.target.files[0])
        document.getElementById("file").value = "";
        document.getElementById("file").file = null;
    }
    changePhoto = async (file) => {
        
        if (!file.type.includes("image")) {
            alert("error", "แจ้งเตือน", "ไม่สามารถอัพโหลดไฟล์ได้เนื่องจากไม่รองรับรูปแบบไฟล์");
            return
        }
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (e) => { }
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file, 512, 512, "JPG", 100, 0,
                (uri) => {
                    this.setState({ picture: uri.split(",")[1] })
                },
                "base64"
            );
        });
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="จัดการระบบ" page3="จัดการผู้ใช้งาน" />
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                            <h3 className="mb-2"><b>จัดการผู้ใช้งาน</b></h3>
                            <div className="d-flex">
                                <button className="btn btn-outline-orange mx-1" onClick={() => { window.location.href = "/master" }}>
                                    <span className="icon me-2">{"\uf060"}</span>ย้อนกลับ
                                </button>
                                <button className="btn btn-orange mx-1" onClick={() => {
                                    this.setState({
                                        modal_create: true,
                                        user_id: "",
                                        user_code: "",
                                        full_name: "",
                                        phone: "",
                                        email: "",
                                        role_id: "",
                                        role_name: "",
                                        picture: "",
                                        is_active: false,
                                        user_type: "admin",
                                    })
                                }}>
                                    เพิ่มพนักงาน
                                </button>
                            </div>
                        </div>
                        <div className="w-100 card border-0 p-0">
                            <div className="d-flex flex-wrap mx-0 px-3 pt-3">
                                <input
                                    className="form-control wpx-250 bg-contain border-0 mx-1 mb-2"
                                    type="text"
                                    placeholder=""
                                    onChange={(e) => { this.setState({ data_search: e.target.value }) }}
                                    onKeyUp={(e) => {
                                        if (e.key === "Enter") {
                                            this.setState({ page: 1, user_id: "" });
                                            setTimeout(() => {
                                                this.Get();
                                            }, 10);
                                        }
                                    }}
                                    value={this.state.data_search}
                                />
                                <button className="btn btn-orange mx-1" onClick={() => {
                                    this.setState({ page: 1, user_id: "" });
                                    setTimeout(() => {
                                        this.Get();
                                    }, 10);
                                }}>
                                    ค้นหา
                                </button>
                                <button className="btn btn-outline-orange mx-1" onClick={() => {
                                    this.setState({ page: 1, data_search: "", user_id: "" });
                                    setTimeout(() => {
                                        this.Get();
                                    }, 10);
                                }}>
                                    รีเซ็ต
                                </button>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-borderless table-striped">
                                    <thead className="bg-primary">
                                        <tr>
                                            <th className="text-center text-white">รหัสพนักงาน</th>
                                            <th className="text-left text-white">ชื่อ-นามสกุล</th>
                                            <th className="text-center text-white">หมายเลขโทรศัพท์</th>
                                            <th className="text-left text-white">Email</th>
                                            <th className="text-center text-white">ประเภท</th>
                                            <th className="text-center text-white">บทบาท</th>
                                            <th className="text-center text-white">สถานะ</th>
                                            <th className="text-center text-white">จัดการ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data && this.state.data.data.map((item, index) => (
                                            <tr key={index}>
                                                <td className="text-center">{item.user_code ? item.user_code : "-"}</td>
                                                <td className="text-left">{item.full_name ? item.full_name : "-"}</td>
                                                <td className="text-center">{item.phone ? item.phone : "-"}</td>
                                                <td className="text-left">{item.email ? item.email : "-"}</td>
                                                <td className="text-center">{item.user_type === "technician" ? "ช่าง" : "พนักงาน"}</td>
                                                <td className="text-center">{item.role_data ? item.role_data.role_name : "-"}</td>
                                                <td className={"text-center " + (item.is_active === true ? "text-success" : "text-danger")}>{item.is_active === true ? "ใช้งาน" : "ไม่ใช้งาน"}</td>
                                                <td className="text-center">
                                                    <div className="w-100 d-flex justify-content-center">
                                                        <div className="pointer wpx-30 hpx-30 rounded bg-primary-light mx-1 d-flex justify-content-center align-items-center"
                                                            onClick={() => {
                                                                this.setState({
                                                                    modal_update: true,
                                                                    user_id: item.user_id,
                                                                    user_code: item.user_code,
                                                                    full_name: item.full_name,
                                                                    phone: item.phone,
                                                                    email: item.email,
                                                                    role_id: { value: item.role_data.role_id, label: item.role_data.role_name },
                                                                    picture: item.picture,
                                                                    is_active: item.is_active,
                                                                    user_type: item.user_type
                                                                })
                                                            }}>
                                                            <label className="pointer icon text-primary p-2">{"\uf044"}</label>
                                                        </div>
                                                        <div className="pointer wpx-30 hpx-30 rounded bg-primary-light mx-1 d-flex justify-content-center align-items-center"
                                                            onClick={() => {
                                                                this.setState({
                                                                    modal_password: true,
                                                                    user_id: item.user_id,
                                                                    user_code: item.user_code,
                                                                    full_name: item.full_name,
                                                                    phone: item.phone,
                                                                    email: item.email,
                                                                    role_id: { value: item.role_data.role_id, label: item.role_data.role_name },
                                                                    picture: item.picture,
                                                                    is_active: item.is_active,
                                                                    user_type: item.user_type
                                                                })
                                                            }}>
                                                            <label className="pointer icon text-primary p-2">{"\uf084"}</label>
                                                        </div>
                                                        <div className="pointer wpx-30 hpx-30 rounded bg-danger-light mx-1 d-flex justify-content-center align-items-center"
                                                            onClick={() => {
                                                                this.setState({
                                                                    modal_delete: true,
                                                                    user_id: item.user_id,
                                                                    user_code: item.user_code,
                                                                    full_name: item.full_name,
                                                                    phone: item.phone,
                                                                    email: item.email,
                                                                    role_id: { value: item.role_data.role_id, label: item.role_data.role_name },
                                                                    picture: item.picture,
                                                                    is_active: item.is_active,
                                                                    user_type: item.user_type
                                                                })
                                                            }}>
                                                            <label className="pointer icon text-danger p-2">{"\uf2ed"}</label>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {/* pagination */}
                                {this.state.data && (
                                    <div className="d-flex flex-wrap justify-content-between w-100 px-3 mt-3">
                                        <label>
                                            แสดง {this.state.data.end_index} รายการ จาก {this.state.data.count} รายการ
                                        </label>
                                        <Pagination
                                            count={this.state.data.page_number}
                                            page={this.state.data.page}
                                            color="primary"
                                            showFirstButton
                                            shape="rounded"
                                            showLastButton
                                            onChange={(event, value) => {
                                                this.setState({ page: value })
                                                setTimeout(() => { this.Get() }, 5)
                                            }} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {/* create update */}
                <Modal show={this.state.modal_create || this.state.modal_update}
                    onHide={() => { this.setState({ modal_create: false, modal_update: false }) }}>
                    <Modal.Header><Modal.Title><b>{this.state.modal_create ? "เพิ่มพนักงาน" : "แก้ไขพนักงาน"}</b></Modal.Title></Modal.Header>
                    <Modal.Body>
                        {/* รูปสาขา */}
                        <div className="w-100 mb-2">
                            {this.state.picture === "" ? (
                                <div
                                    className="w-100 pointer card d-flex align-items-center justify-content-center px-3 py-5 bg-light rounded hpx-200"
                                    onClick={() => { document.getElementById("file").click() }}
                                >
                                    <label className="icon text-secondary pointer">{"\uf0ee"}</label>
                                    <label className="text-secondary pointer">อัปโหลดรูปภาพ</label>
                                </div>
                            ) : (
                                <div className="w-100 card border-2 border-orange d-flex align-items-center justify-content-center p-2  mb-2">
                                    <div className="position-relative w-100">
                                        <img alt="รูปสาขา" src={this.state.picture.includes("https://") ? this.state.picture : "data:image/png;base64," + this.state.picture} className="w-100 rounded overflow-hidden"></img>
                                        <div className="icon pointer bg-danger text-white position-absolute wpx-30 hpx-30 d-flex justify-content-center align-items-center rounded-circle" style={{ top: -8, right: -8 }} onClick={() => { this.setState({ picture: "" }) }}>
                                            {"\uf00d"}
                                        </div>
                                    </div>
                                </div>
                            )}
                            <input className="d-none" type="file" id="file" accept="image/*" onChange={(e) => { this.import_file(e, "main") }} />
                        </div>
                        <hr />
                        {/* ชื่อ-นามสกุล */}
                        <div className="w-100 mb-2">
                            <label className="mb-2">ชื่อ-นามสกุล:</label>
                            <input
                                className="form-control"
                                type="text"
                                placeholder=""
                                onChange={(e) => { this.setState({ full_name: e.target.value }) }}
                                value={this.state.full_name}
                            />
                        </div>
                        {/* เบอร์โทร */}
                        <div className="w-100 mb-2">
                            <label className="mb-2">เบอร์โทร:</label>
                            <input
                                className="form-control"
                                type="tel"
                                maxLength={10}
                                placeholder=""
                                onChange={(e) => {
                                    if (!float(e.target.value)) {
                                        return
                                    }
                                    this.setState({ phone: e.target.value })
                                }}
                                value={this.state.phone}
                            />
                        </div>
                        {/* ประเภท */}
                        <div className="w-100 mb-2">
                            <label className="mb-2">ประเภท:</label>
                            <select className="form-control" onChange={(e) => {
                                this.setState({ user_type: e.target.value })
                            }}
                                value={this.state.user_type}>
                                <option value="admin">พนักงาน</option>
                                <option value="technician">ช่าง</option>
                            </select>
                        </div>
                        {/* บทบาท */}
                        <div className="w-100 mb-2">
                            <label className="mb-2">บทบาท:</label>
                            <Select
                                className="form-control select-search"
                                styles={select_style}
                                options={this.state.data_role}
                                onChange={(e) => {
                                    this.setState({ role_id: e });
                                }}
                                value={this.state.role_id}
                                isClearable
                            ></Select>
                        </div>
                        {/* Email/Username */}
                        <div className="w-100 mb-2">
                            <label className="mb-2">Email/Username:</label>
                            <input
                                className="form-control"
                                type="email"
                                placeholder=""
                                onChange={(e) => {
                                    this.setState({ email: e.target.value })
                                }}
                                value={this.state.email}
                            />
                        </div>
                        {/* สถานะ */}
                        {/* {this.state.modal_update && (
                            <div className="w-100 mb-2">
                                <label className="mb-2">สถานะ:</label><br />
                                <Switch onChange={(e) => {
                                    this.setState({
                                        is_active: e,
                                    })
                                }} checked={this.state.is_active} />
                            </div>
                        )} */}
                        {/* รหัสผ่าน */}
                        {this.state.modal_create && (
                            <div className="w-100 mb-2">
                                <label className="mb-2">รหัสผ่าน:</label>
                                <div className="d-flex">
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => {
                                            this.setState({ password: e.target.value })
                                        }}
                                        value={this.state.password}
                                    />
                                    <button className="btn btn-primary px-4 ms-2 wpx-120" onClick={async () => { this.setState({ password: await random_charactor(6) }) }}>สุ่มรหัส</button>
                                </div>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-outline-orange w-100" onClick={() => { this.setState({ modal_create: false, modal_update: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-orange w-100"
                                    onClick={() => {
                                        if (this.state.modal_create) {
                                            this.Create();
                                        } else {
                                            this.Update();
                                        }
                                    }}>
                                    {this.state.modal_create ? "เพิ่ม" : "บันทึก"}
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
                {/* create update */}
                <Modal show={this.state.modal_password}
                    onHide={() => { this.setState({ modal_password: false }) }}>
                    <Modal.Header><Modal.Title><b>รีเซ็ทรหัสผ่าน</b></Modal.Title></Modal.Header>
                    <Modal.Body>
                        {/* รหัสผ่าน */}
                        <div className="w-100 mb-2">
                            <label className="mb-2">รหัสผ่าน:</label>
                            <div className="d-flex">
                                <input
                                    className="form-control"
                                    type="text"
                                    placeholder=""
                                    onChange={(e) => {
                                        this.setState({ password: e.target.value })
                                    }}
                                    value={this.state.password}
                                />
                                <button className="btn btn-primary px-4 ms-2 wpx-120" onClick={async () => { this.setState({ password: await random_charactor(6) }) }}>สุ่มรหัส</button>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-outline-orange w-100" onClick={() => { this.setState({ modal_password: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-orange w-100"
                                    onClick={() => {
                                        this.Update();
                                    }}>
                                    บันทึก
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
                {/* ลบข้อมูล */}
                <Modal show={this.state.modal_delete} onHide={() => { this.setState({ modal_delete: false }) }}>
                    <Modal.Header> <Modal.Title> <b>ต้องการลบสมาชิก</b> </Modal.Title> </Modal.Header>
                    <Modal.Body>
                        <label>
                            ท่านต้องการลบสมาชิก “{this.state.full_name}”
                        </label>
                    </Modal.Body>
                    <Modal.Footer>
                        <label className="mb-2 w-100">
                            หมายเหตุ ไม่สามารถกู้คืนได้
                        </label>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-danger w-100" onClick={() => { this.Delete() }}>
                                    ลบ
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-outline-danger w-100" onClick={() => { this.setState({ modal_delete: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div >
        )
    }
}
